"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'altacogni',
    userFriendlyName: 'Altacogni',
    logo: require('./logo.svg').default,
    colors: {
        primary: '#000',
        primaryText: '#fff',
        primaryDark: '#222',
        accentBackgroundedText: '#FFF',
        pageBackground: '#f6f6f6',
    },
});
//# sourceMappingURL=index.js.map